import DoubleArrowOutlinedIcon from "@mui/icons-material/DoubleArrowOutlined";
import LockIcon from "@mui/icons-material/Lock";
import AccountCircle from "@mui/icons-material/AccountCircle";
import { Box, IconButton, Tooltip } from "@mui/material";
import React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { IModifyUser } from "ui/Scripts/source/models/user/modifyUser";
import { AvatarImage } from "ui/Scripts/source/components/framework/Avatar/AvatarImage";
import { UnlockToolButton } from "../../Button/UnlockToolButton";
import { Base } from "ui/Scripts/source/framework/base";

interface DialogItemsNavProps {
  hasPrevious: boolean;
  hasNext: boolean;
  createUser?: IModifyUser;
  modifyUser?: IModifyUser;
  publishUser?: IModifyUser;
  archiveUser?: IModifyUser;
  deleteUser?: IModifyUser;
  lockedUser?: IModifyUser;
  isLockedToOtherUser?: boolean;
  onUnlockAndLockToMe?: () => void;
  onPrevious: () => Promise<void>;
  onNext: () => Promise<void>;
}

export const DialogItemsNav = ({
    hasPrevious,
    hasNext,
    createUser,
    modifyUser,
    publishUser,
    archiveUser,
    deleteUser,
    lockedUser,
    isLockedToOtherUser,
    onUnlockAndLockToMe,
    onPrevious,
    onNext,
}: DialogItemsNavProps) => (
    <Box display="flex">
        {!!onPrevious &&
            <Tooltip
                title={!hasPrevious && Translations.Previous}
                sx={{ marginRight: "1.5rem" }}
            >
                <span>
                    <IconButton onClick={onPrevious} disabled={!hasPrevious}>
                        <DoubleArrowOutlinedIcon sx={{ transform: "rotate(180deg)" }} />
                    </IconButton>
                </span>
            </Tooltip>
        }
        {!!onNext &&
            <Tooltip title={Translations.Next}>
                <span>
                    <IconButton onClick={onNext} disabled={!hasNext}>
                        <DoubleArrowOutlinedIcon />
                    </IconButton>
                </span>
            </Tooltip>
        }
        <Box display="flex" alignItems="center" sx={{ marginLeft: onPrevious || onNext ? "1rem" : undefined }}>
            {isLockedToOtherUser &&
                <Box color="warning.main" display="flex" alignItems="center" sx={{ marginLeft: onPrevious || onNext ? ".5rem" : undefined }}>
                    {(onUnlockAndLockToMe
                        ? <UnlockToolButton
                            color="warning"
                            sx={{ marginTop: "-8px", marginBottom: "-8px" }}
                            onClick={onUnlockAndLockToMe}
                        />
                        : <Tooltip title={`${Translations.LockedToUser}: ${lockedUser.name} - ${lockedUser.date ? Base.timeToDateTimeStr(lockedUser.date) : ""}`}>
                            <LockIcon />
                        </Tooltip>
                    )}
                    <Tooltip title={`${Translations.LockedToUser}: ${lockedUser.name} - ${lockedUser.date ? Base.timeToDateTimeStr(lockedUser.date) : ""}`}>
                        <Box sx={{ marginLeft: ".2rem", marginRight: ".5rem" }}>
                            <AvatarImage
                                id={lockedUser.code ?? lockedUser.name}
                                name={lockedUser.name}
                                image={lockedUser.picture}
                            />
                        </Box>
                    </Tooltip>
                </Box>
            }
            {(!!createUser || !!modifyUser || !!deleteUser) &&
                <Box display="flex" alignItems="center" sx={{ marginLeft: onPrevious || onNext || isLockedToOtherUser ? ".5rem" : undefined }}>
                    <Tooltip title={Translations.Users}>
                        <AccountCircle />
                    </Tooltip>
                    {!!createUser &&
                        <Tooltip title={`${Translations.Created}: ${createUser.name} - ${createUser.date ? Base.timeToDateTimeStr(createUser.date) : ""}`}>
                            <Box sx={{ marginLeft: ".5rem" }}>
                                <AvatarImage
                                    id={createUser.code ?? createUser.name}
                                    name={createUser.name}
                                    image={createUser.picture}
                                />
                            </Box>
                        </Tooltip>
                    }
                    {!!modifyUser &&
                        <Tooltip title={`${Translations.Modified}: ${modifyUser.name} - ${modifyUser.date ? Base.timeToDateTimeStr(modifyUser.date) : ""}`}>
                            <Box sx={{ marginLeft: ".5rem" }}>
                                <AvatarImage
                                    id={modifyUser.code ?? modifyUser.name}
                                    name={modifyUser.name}
                                    image={modifyUser.picture}
                                />
                            </Box>
                        </Tooltip>
                    }
                    {!!publishUser &&
                        <Tooltip title={`${Translations.Published}: ${publishUser.name} - ${publishUser.date ? Base.timeToDateTimeStr(publishUser.date) : ""}`}>
                            <Box sx={{ marginLeft: ".5rem" }}>
                                <AvatarImage
                                    id={publishUser.code ?? publishUser.name}
                                    name={publishUser.name}
                                    image={publishUser.picture}
                                />
                            </Box>
                        </Tooltip>
                    }
                    {!!archiveUser &&
                        <Tooltip title={`${Translations.Archived}: ${archiveUser.name} - ${archiveUser.date ? Base.timeToDateTimeStr(archiveUser.date) : ""}`}>
                            <Box sx={{ marginLeft: ".5rem" }}>
                                <AvatarImage
                                    id={archiveUser.code ?? archiveUser.name}
                                    name={archiveUser.name}
                                    image={archiveUser.picture}
                                />
                            </Box>
                        </Tooltip>
                    }
                    {!!deleteUser &&
                        <Tooltip title={`${Translations.MovedToTrashBin}: ${deleteUser.name} - ${deleteUser.date ? Base.timeToDateTimeStr(deleteUser.date) : ""}`}>
                            <Box sx={{ marginLeft: ".5rem" }}>
                                <AvatarImage
                                    id={deleteUser.code ?? deleteUser.name}
                                    name={deleteUser.name}
                                    image={deleteUser.picture}
                                />
                            </Box>
                        </Tooltip>
                    }
                </Box>
            }
        </Box>
    </Box>
);
